import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const LeadsNotificationPreferencesModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "LeadsNotificationPreferencesModalContainer" */
      './LeadsNotificationPreferencesModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
